<div class="content">
    <div class="title">
        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1016 9.81836V13.2469C20.1016 14.7326 16.5198 16.6755 12.1016 16.6755C7.68328 16.6755 4.10156 14.7326 4.10156 13.2469V10.3898" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.4375 10.6862C5.42607 11.9982 8.48322 13.229 12.1015 13.229C16.5198 13.229 20.1015 11.3936 20.1015 9.81644C20.1015 8.93073 18.9735 7.96044 17.2032 7.2793" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.6758 4.10352V7.53209C16.6758 9.0178 13.0941 10.9607 8.67578 10.9607C4.2575 10.9607 0.675781 9.0178 0.675781 7.53209V4.10352" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.67578 7.51464C13.0941 7.51464 16.6758 5.67921 16.6758 4.10207C16.6758 2.52378 13.0941 0.675781 8.67578 0.675781C4.2575 0.675781 0.675781 2.52378 0.675781 4.10207C0.675781 5.67921 4.2575 7.51464 8.67578 7.51464Z" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h2>Comprar Rewards</h2>
    </div>
    <div class="body" [formGroup]="formRewards">
        <div class="add-payment">
        @for (item of listButons; track $index) {
        <lib-ribera-default-btn
        [ngClass]="{'is-selected': selected() !== $index}"
        variant="primary"
        borderRadius="24px"
        (press)="selectedOption($index)"
        >
        {{ item.label }}
        </lib-ribera-default-btn>
        }
        </div>

        <lib-ribera-input-form-ui
        [label]="'Quiero USD rewards'"
        [id]="'usds'"
        [control]="getControl('usds')"
        [placeholder]="'0 USD Rewards'"
        style="width: 100%;"
        >
        </lib-ribera-input-form-ui>

        <lib-ribera-input-form-ui
        [label]="'Recompensas obtenidas'"
        [id]="'rewards'"
        [control]="getControl('rewards')"
        [placeholder]="'0.0 USD'"
        style="width: 100%;"
        >
        </lib-ribera-input-form-ui>
        <p>
        <span>Términos y condiciones para la compra de USD Rewards.</span>
        <br> El precio es de 1 USD por cada punto. Se cobrará en la moneda local respetando el tipo de cambio vigente al momento de la compra.
        </p>
        <lib-ribera-default-btn
        variant="primary"
        borderRadius="10px"
        [size]="'large'"
        (press)="convetRewards()"
        [disabled]="formRewards.invalid"
        >
        <span style="font-size: 16px;">Convertir Rewards</span>
        </lib-ribera-default-btn>
    </div>
</div>
